import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  MemberTier as MemberTierComponent,
  MemberTierProps,
} from "../../components/MemberTier/MemberTier";
import { getMemberTierCustomerAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";

interface MemberTierContainerProps extends MemberTierProps {
  getMemberTierCustomerAction: typeof getMemberTierCustomerAction;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
}

class MemberTier extends React.Component<MemberTierContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getMemberTierCustomerAction();
    }
  }

  render() {
    return <MemberTierComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsMemberTierLoading(state),
  memberTierCustomer: getMemberTierCustomer(state),
});

export default connect(mapStateToProp, {
  getMemberTierCustomerAction,
})(MemberTier);
